
import Component from "vue-class-component";
import Vue, {CreateElement, VNode} from "vue";
import { CheckRoleAndAuthorities } from "@/lib/helpers/componentViewController/decorators";
import { Prop } from "vue-property-decorator";

@Component({ name: "WrapperCheckRoleAndAuthorities" })
export default class WrapperCheckRoleAndAuthorities extends Vue {
  @Prop({ type: String })
  public readonly ruleName!: string;

  @Prop({ type: String, required: true })
  public readonly authRuleKey!: string;

  @Prop({ type: String, required: true })
  public readonly currentUserRole!: string;

  @CheckRoleAndAuthorities(
    ctx => ctx.ruleName,
    ctx => ctx.currentUserRole,
    ctx => ctx.authRuleKey
  )
  public allowRender!: boolean;

  private render(h: CreateElement): VNode {
    if (!this.allowRender) return h();
    const component = this.$scopedSlots.default && this.$scopedSlots.default({});
    if (component && component.length === 1) return component[0];
    return h("span", {}, component);
  }
}
